























import {
  defineComponent,
  useFetch,
  ref
} from '@nuxtjs/composition-api';
import { SfHeading, SfButton } from '@storefront-ui/vue';
import { useAttachments, AttachmentInterface } from '@wemade-vsf/theme';

export default defineComponent({
  name: 'AttachmentList',
  props: {
    title: {
      type: String,
      default: ''
    },
    attachmentIds:  {
      type: String,
      default: ''
    }
  },
  components: {
    SfHeading,
    SfButton
  },
  setup (props) {
    const { getAttachments } = useAttachments();
    const attachments = ref<AttachmentInterface[]|null>(null)
    const ids = props.attachmentIds.split(',').map(i => parseInt(i)).filter(Boolean);

    useFetch(async() => {
      if (ids.length) {
        attachments.value = await getAttachments(ids)
      }
    })

    const download = (attachment: AttachmentInterface) => {
      if (process.server) return
      const url = attachment.file || attachment.url
      if (url) {
        window.open(url)
      }
    }

    return {
      attachments,
      download
    }
  }
})
